
























import {
	Component,
	Prop,
	Vue,
	Inject,
	Ref,
	Watch,
} from 'vue-property-decorator';
import { ClassType } from 'class-transformer/ClassTransformer';
import { Search, SortDirection } from '@/data/models/search.model';
import { Page } from '@/data/models/page.model';
import { CrudService } from '@/data/services/crud.service';

@Component
export default class EntityAutocomplete extends Vue {
	@Prop() value?: any;

	@Prop() entityClass!: ClassType<any>;
	@Prop() entityName!: string;
	@Prop() entityField!: string;
	@Prop({ default: 'like' }) entityFilterType!: string;
	@Prop() entityFilterField?: string;
	@Prop() entityLikeType?: string;
	@Prop() entityFormatter?: any;
	@Prop({ default: 20 }) entityFilterLength!: number;
	@Prop() entitySearch?: Search;
	@Prop({ default: false }) expanded?: boolean;
	@Prop() placeholder?: string;
	@Prop({ default: false }) disabled!: boolean;
	@Prop({ default: false }) allowNew!: boolean;

	@Inject('CrudService') crudService!: CrudService<any>;

	@Ref('autocomplete') autocomplete: any;

	newValue: any;
	items: any[] = [];
	advancedSearch!: Search;
	page!: Page;
	loading: boolean = false;

	_intervalRef?: any = null;

	@Watch('value')
	onValueChange(value: any) {
		if (value !== this.newValue) {
			this.autocomplete.setSelected(value);
		}
	}

	onTyping(term: string) {
		if (this.allowNew) {
			this.newValue = term;
			this.onSelectItem(term);
		}
		this.loadData(term);
	}

	loadData(term: string) {
		if (term) {
			clearTimeout(this._intervalRef);
			this._intervalRef = setTimeout(() => {
				this.loading = true;
				if (this.entityFilterType === 'simple') {
					this.advancedSearch.addSimpleFilter(this.field, term);
				} else if (this.entityFilterType === 'like') {
					this.advancedSearch.addLikeFilter(this.field, term, this.entityLikeType);
				}
				this.crudService
					.searchEntities(
						this.entityClass,
						this.entityName,
						this.advancedSearch,
						this.page
					)
					.then((result) => {
						this.items = result;
					})
					.finally(() => (this.loading = false));
			}, 500);
		} else {
			this.items = [];
		}
	}

	onSelectItem(event: any) {
		this.newValue = event;
		this.$emit('input', event);
	}

	reset() {
		this.autocomplete.setSelected({});
	}

	setSelected(model: any) {
		this.autocomplete.setSelected(model);
	}

	beforeMount() {
		if (this.entitySearch) {
			this.advancedSearch = this.entitySearch;
		} else {
			this.advancedSearch = new Search(this.entityName);
			this.advancedSearch.setSortField(this.field);
			this.advancedSearch.setSortDirection(SortDirection.ASCENDING);
		}
		this.page = new Page(this.entityFilterLength);
	}

	mounted() {
		if (this.value) {
			this.autocomplete.setSelected(this.value);
		}
	}

	get field(): string {
		return this.entityFilterField || this.entityField;
	}
}
